import React from "react";
import { Box } from "@mui/material";

const AuthHeroColumn = ({ isMobile, variant = "register" }) => {
  const isLogin = variant === "login";

  return (
    <Box
      sx={{
        width: isMobile ? "0%" : "60%",
        display: isMobile ? "none" : "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        background:
          "linear-gradient(135deg, #000000 0%, #1a1a1a 25%, #2a2a2a 50%, #1a1a1a 75%, #000000 100%)",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background:
            "radial-gradient(circle at 30% 30%, rgba(51, 51, 51, 0.1) 0%, transparent 50%)",
          pointerEvents: "none",
        },
      }}
    >
      {/* Decorative Elements */}
      <Box
        sx={{
          position: "absolute",
          top: "15%",
          left: "10%",
          width: "120px",
          height: "120px",
          borderRadius: "50%",
          background:
            "linear-gradient(45deg, rgba(51, 51, 51, 0.3), rgba(102, 102, 102, 0.1))",
          filter: "blur(40px)",
          animation: "float 6s ease-in-out infinite",
          "@media (max-width: 768px)": {
            display: "none",
          },
        }}
      />
      <Box
        sx={{
          position: "absolute",
          bottom: "25%",
          right: "10%",
          width: "180px",
          height: "180px",
          borderRadius: "50%",
          background:
            "linear-gradient(45deg, rgba(51, 51, 51, 0.2), rgba(102, 102, 102, 0.05))",
          filter: "blur(60px)",
          animation: "float 8s ease-in-out infinite reverse",
          "@media (max-width: 768px)": {
            display: "none",
          },
        }}
      />

      {/* Logo */}
      <Box
        component="img"
        src="./LogoNew.png"
        alt="Company Logo"
        sx={{
          position: "absolute",
          top: 40,
          left: 40,
          width: "120px",
          height: "auto",
          zIndex: 10,
          filter: "drop-shadow(0 4px 8px rgba(0,0,0,0.5))",
          "@media (max-width: 1024px) and (min-width: 768px)": {
            top: 20,
            left: 20,
            width: "60px",
            zIndex: 15,
          },
        }}
      />

      {/* Darren Image - Main Focus */}
      <Box
        sx={{
          position: "relative",
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background:
              "linear-gradient(45deg, rgba(0,0,0,0.3) 0%, transparent 50%, rgba(51, 51, 51, 0.1) 100%)",
            zIndex: 1,
            ...(isLogin && {
              "@media (max-width: 768px)": {
                background: "transparent",
              },
            }),
          },
        }}
      >
        <Box
          component="img"
          src="./DarrenImage.png"
          alt="Darren Vermost"
          sx={{
            maxHeight: "85vh",
            maxWidth: "90%",
            width: "auto",
            height: "auto",
            objectFit: "contain",
            borderRadius: "20px",
            boxShadow:
              "0 20px 60px rgba(0,0,0,0.8), 0 0 40px rgba(51, 51, 51, 0.2)",
            border: "2px solid rgba(51, 51, 51, 0.3)",
            zIndex: 2,
            filter: "contrast(1.1) brightness(1.05)",
            ...(isLogin && {
              "@media (max-width: 768px)": {
                boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
                border: "none",
                filter: "none",
              },
            }),
          }}
        />
      </Box>
    </Box>
  );
};

export default AuthHeroColumn;
